// See backend.orderkiosk.models.Schedule for definition of types
import moment from "moment";

const SCHEDULE_CONTINOUS_TYPE = 0;
const SCHEDULE_DAILY_TYPE = 1;

export const checkSchedule = (all_schedules_dict, schedule_id) => {
  const timeFormat = "HH:mm";
  const dateTimeFormat = "YYYY-MM-DD HH:mm";

  const s = all_schedules_dict[schedule_id];
  //Interval Check, is schedule active?
  if (s.start && s.end) {
    const active = moment().isBetween(
      moment(s.start, dateTimeFormat),
      moment(s.end, dateTimeFormat)
    );
    if (!active) {
      return false;
    }
  }
  if (s.weekdays_mask != 0) {
    // isoWeekday: MO=1 (1), TU=2 (2), WE=3 (4), ...
    let weekdayPattern = 2 ** (moment().isoWeekday() -1)
    if (!(s.weekdays_mask & weekdayPattern)){
      return false;
    }
  }
  if (s.type === SCHEDULE_CONTINOUS_TYPE) {
    // active and weekday check have passed and type is continous it is active!
    return true;
  }
  if (s.type === SCHEDULE_DAILY_TYPE && s.dailyStart && s.dailyEnd) {
    // active and weekday check have passed we are of daily type, check daily constraints!
    const isInDailyInterval = moment().isBetween(
      moment(s.dailyStart, timeFormat),
      moment(s.dailyEnd, timeFormat)
    );
    return isInDailyInterval;
  }
  //type is unknown so we default to false here.
  return false;
};

export const checkSchedules = (all_schedules_dict, item) => {
  if (!item) {
    return false;
  }
  if (item.schedules.length === 0) {
    //default case: when no schedules are defined this item is active.
    return true;
  }
  return item.schedules.some(schedule_id =>
    checkSchedule(all_schedules_dict, schedule_id)
  );
};
